import { Button } from "@/components/shadcn/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/shadcn/tooltip";
import useUniversalRouter from "@/hooks/use-universal-router";
import { FileCode2 } from "lucide-react";
import { useEffect, useState } from "react";

const OpenPageInVSCode = () => {
  const { pathname } = useUniversalRouter();
  const [file, setFile] = useState<string | null>(null);

  useEffect(() => {
    fetch(`/api/dev/open-page?path=${pathname}&resolve=true`)
      .then((r) => r.json())
      .then(({ file }) => setFile(file))
      .catch(() => setFile(null));
  }, [pathname]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          onClick={() => fetch(`/api/dev/open-page?path=${pathname}`)}
        >
          <FileCode2 />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{file ?? "No matching page file"}</TooltipContent>
    </Tooltip>
  );
};

export default OpenPageInVSCode;
